export default __webpack_public_path__ + "static/media/tb-team-karim.97c7c8f5.gif";